import { render, staticRenderFns, recyclableRender, components } from "./alipay-h5.vue?vue&type=template&id=5c3624a7&"
var renderjs
import script from "./alipay-h5.vue?vue&type=script&lang=js&"
export * from "./alipay-h5.vue?vue&type=script&lang=js&"
import style0 from "./alipay-h5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/order/alipay-h5/alipay-h5.vue"
export default component.exports